module.exports = __webpack_public_path__ + "img/fail.3d9b3615.svg";